import { useSelector } from "react-redux";
import { forceUnitSelector } from "../containers/Units/selectors";

const useForceUnit = () => {
  const forceUnit = useSelector(forceUnitSelector);
  return forceUnit;
};

export default useForceUnit;
